import { useEffect, useRef, useState } from "react";
import { Plus } from "react-feather";
import InputB from "../../../components/InputB/InputB";
import { EventDTO } from "../../DTO/EventDTO";
import { ObjectKind } from "../../models/objectKinds";
import { PublishKind } from "../../models/publishKinds";
import BuildingBlocksDTO, { CompactType } from "../../DTO/BuildingBlocksDTO";
import Spinner from "../../../components/Spinner/Spinner";
import mainservice from "../../../services/MainService";
import { MItem } from "../Menu";
import { DisplayEvent } from "./DisplayEvent";
import { DateAddDays, DisplayDate, DisplayPHPDate } from "../../../services/DateTime";
import './EventList.scss'
import { SeminarDTO } from "../../DTO/SeminarDTO";
import { PersonKind } from "../Person/PersonKind";
import PlaningToolRoot from "../PlaningToolRoot";
import BroadcastRightButton from "../../elements/BroadcastRightButton";
import { RightDrawerContent } from "../RightDrawer";
import { Status } from "../day/dayView";
import { InfinitScroll } from "../../../services/InfinitScroll";
import { IProp } from "../../DTO/PropDTO";
import { Help } from "../Help";
import { minDateSaverService } from "../../../services/MinDateSaverService";
import { sessionDataSaver } from "../../../services/SessionDataSaver";
import TrainersGantt from "../Person/TrainersGantt";
import TrainersGantt90 from "../Person/TrainersGantt90";
import EventCopyModal from "./EventCopyModal";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import DeleteIcon from '@mui/icons-material/Delete';
import { Alert, Button, Box, Tabs, Tab, Stack, Typography } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { parseStringFromServer } from "../../../services/TextConverter";

const DisplayKinds = [
  {
    name: 'Liste',
    key: 'list',
  },
  {
    name: 'Gantt',
    key: 'gantt',
  },
  {
    name: 'Unterminiert',
    key: 'listwithoutdate',
  },
  {
    name: 'Trainer',
    key: 'trainerGantt90'
  },
]

export default function EventList(props: {
  blacklist?: number[],
  className?: string,
  customerId?: number,
  customerLocationId?: number,
  locationId?: number,
  personId?: number,
  standalone?: boolean,
  noSearch?: boolean,
  rerenderTrigger?: number,
  selected?: number,
  onSelect?: (id: number, event: EventDTO) => void,
  noNew?: boolean,
  objectKind?: ObjectKind,
  publishKind?: PublishKind,
  allowRemove?: boolean,
  minDateFilter?: boolean,
  onlyWithoutCustomer?: boolean,
  onlyWithoutCustomerLocation?: boolean,
  onlyWithoutLocation?: boolean,
  personKind?: PersonKind,
  compact?: CompactType,
  headline?: string,
  leads?: string,
  mode?: 'trash' | 'staffEvents',
  ignoreDate?: '' | 'ignore',
  limit?: number,
  sort?: string,
  searchPlaceholder?: string,
}) {
  const SLPlaceholder = props.standalone ? 'Standalone' : 'Local'
  const rememberNeedles = !!props.standalone
  const searchNeedlePlaceholder = `${SLPlaceholder}-eventNeedle`
  const currentPagePlaceholder = `${SLPlaceholder}-currentPage`
  const currentScrollPositionPlaceholder = `${SLPlaceholder}-currentScrollPosition`
  const oldPage = sessionDataSaver.get(currentPagePlaceholder, rememberNeedles)
  const page = mainservice.nav.getVal('page') as number || 0
  // const objectKind = props.objectKind ? props.objectKind : ObjectKind.event
  const [objectKind, setObjectKind] = useState(props.objectKind ? props.objectKind : ObjectKind.event)
  const [publishKind, setPublishKind] = useState(props.publishKind === undefined ? PublishKind.isTemplate : props.publishKind)
  const [Needle, setNeedle] = useState(sessionDataSaver.get(searchNeedlePlaceholder, rememberNeedles))
  const [status, setStatus] = useState(Status.loading)
  const [displayKind, setDisplayKind] = useState(DisplayKinds[page]?.key || 'list')
  const [buildingBlocksDTO] = useState(new BuildingBlocksDTO({
    customerId: props.customerId || -1,
    customerLocationId: props.customerLocationId || -1,
    locationId: props.locationId || -1,
    personId: props.personId || -1,
    onlyWithoutCustomer: !!props.onlyWithoutCustomer,
    onlyWithoutCustomerLocation: !!props.onlyWithoutCustomerLocation,
    onlyWithoutLocation: !!props.onlyWithoutLocation,
    personKind: props.personKind,
    compact: props.compact,
    leads: props.leads,
    mode: props.mode || 'normal',
    minDate: (props.minDateFilter) ? DisplayPHPDate(minDateSaverService.get()) : 'ignore',
    publishKind: publishKind,
    ignoreDate: props.ignoreDate,
    limit: props.limit,
    needle: Needle,
    sort: props.sort,
  }));
  const [minDate, setMinDate] = useState(minDateSaverService.get())
  const [infinitScroll] = useState(new InfinitScroll({
    ref: useRef(null),
    cb: async () => {
      // What to do, if we are at the end of the list?
      const newPage = infinitScroll.incrementAndLock()
      if (newPage === -1) { return }
      setStatus(Status.loadMore)
      sessionDataSaver.set(currentPagePlaceholder, `${newPage}`)
      const newElementCount = await buildingBlocksDTO.setElementKindPage(newPage, undefined, publishKind)
      if (newElementCount) {
        infinitScroll.unlock()
      }
      setStatus(Status.standard)
      // Now load new content - then set Status to "standard" and unlock
      // If nothing is loaded - lock permanently
    },
    saveScrollPositionCb: (scrollPosition: number) => {
      sessionDataSaver.set(currentScrollPositionPlaceholder, `${scrollPosition}`)
    },
    page: parseInt(oldPage, 10) || 0,
  }))
  function setGlobNeedle(n: string) {
    sessionDataSaver.set(searchNeedlePlaceholder, n)
    setNeedle(n)
  }
  function setGlobMinDate(d: Date) {
    minDateSaverService.set(d)
    setMinDate(d)
    infinitScroll.unlock()
  }
  useEffect(() => {
    const oK = props.objectKind || ObjectKind.event
    setObjectKind(oK)
    const pK = props.publishKind === undefined ? PublishKind.isTemplate : props.publishKind
    setPublishKind(pK)
    setStatus(Status.loading)
    // infinitScroll.setPage(0)
    const oldScrollPosition = parseInt(sessionDataSaver.get(currentScrollPositionPlaceholder, rememberNeedles)) || 0
    // Lade die Inhalte entsprechend des Object Kinds
    buildingBlocksDTO.setElementKindPage(0, oK, pK).then(() => {
      setStatus(Status.standard);
      infinitScroll.scrollToPosition(oldScrollPosition)
    });
  }, [props.objectKind, props.publishKind])
  useEffect(() => {
    setStatus(Status.loading)
    if (props.minDateFilter) {
      buildingBlocksDTO.minDate = DisplayPHPDate(minDate)
    }
    const oldScrollPosition = parseInt(sessionDataSaver.get(currentScrollPositionPlaceholder, rememberNeedles)) || 0
    buildingBlocksDTO.setElementKindPage(-1 * parseInt(oldPage, 10 ), objectKind, publishKind).then(() => {
      setStatus(Status.standard);
      infinitScroll.scrollToPosition(oldScrollPosition)
    });
  }, [props.rerenderTrigger]);
  const items = buildingBlocksDTO.ShowEvents()
  const searchPlaceholder = props.searchPlaceholder || `Tippen um zu suchen oder neu anzulegen ... ${objectKind === ObjectKind.event ? 'Um Nach Trainern zu filtern die Trainer E-Mail eingeben. Veranstaltungsnummer mit # beginnen.' : ''}`
  const prepareGantt = buildingBlocksDTO.prepareGantt(items)
  const displayItems = items.filter((item) => {
    if (!props.blacklist || props.blacklist.length === 0 || props.blacklist.every((id) => id !== item.id)) {
      return true
    }
    return false
  }).map((item, index) => {
    const displayEvent = <DisplayEvent
      key={`DisplayEvent-${item.id}-${index}`}
      item={item as EventDTO}
      onClick={props.onSelect}
      onDublicate={props.standalone ? async () => {
        mainservice.broadcast('openmodal', {
          content: <EventCopyModal
            headline={`Wirklich Kopie von ${item.getName()} speichern?`}
            description="Was soll kopiert werden?"
            mode={'copy'}
            okayString={'Kopieren'}
            finishFkt={async (params) => {
              setStatus(Status.loading)
              await buildingBlocksDTO.cloneItem(item.id, objectKind, undefined, params.copySettings)
              setStatus(Status.standard)
            }}
            okayStartIcon={<ContentCopyIcon />}
          />
        })
      } : undefined }
      onDublicateAsDesign={props.standalone && objectKind === ObjectKind.event ? async () => {
        mainservice.broadcast('openmodal', {
          content: <EventCopyModal
            headline={`Wirklich Vorlage von ${item.getName()} erstellen?`}
            description=""
            mode={'copyAsDesign'}
            okayString={'Als Design ablegen'}
            finishFkt={async (params) => {
              setStatus(Status.loading)
              await buildingBlocksDTO.cloneItem(item.id, ObjectKind.seminar, PublishKind.isSeminar, params.copySettings)
              setStatus(Status.standard)
            }}
            okayStartIcon={<ArchitectureIcon />}
          />
        })
      } : undefined }
      onTrash={props.standalone ? async () => {
        const info = await item.trashPreflightInfo('delete')
        mainservice.broadcast('openmodal', {
          content: <Stack spacing={2}>
            <Typography variant="h4">{`Wirklich ${item.getName()} löschen?`}</Typography>
            {
              item.getAppointments().length > 1 &&
              <p className="w3-red w3-padding">
                {item.name} besteht aus mehreren Teilen. Alle Teile würden somit gelöscht. Trotzdem löschen?
              </p>
            }
            <h3>{info.fehlenHeadline}</h3>
            <ul>
              {info.fehlenArr.map((f) => <li>{f}</li>)}
            </ul>
            {info.fehlenArr.length === 0 &&
              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                Wird nirgendwo gebraucht
              </Alert>
            }
            <h3>{info.brauchenHeadline}</h3>
            <ul>
              {info.brauchenArr.map((b) => <li>{b.name}</li>)}
            </ul>
            {info.brauchenArr.length === 0 &&
              <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                Verwendet keine Resourcen
              </Alert>
            }
            <Stack spacing={2} direction="row">
              <Button
                onClick={async () => {
                  mainservice.broadcast('openmodal', {content: null})
                  setStatus(Status.loading)
                  await item.bakeDowns()
                  await buildingBlocksDTO.removeItem(item.id)
                  await item.seminarTrash()
                  setStatus(Status.standard)
                }}
                variant="contained"
                startIcon={<DeleteIcon/>}
              >Löschen</Button>

              <Button
                variant="outlined"
                onClick={() => mainservice.broadcast('openmodal', {content: null})}
              >Abbrechen</Button>
            </Stack>
          </Stack>
        })
      } : undefined}
      onUntrash={props.standalone ? async () => {
        setStatus(Status.loading)
        await buildingBlocksDTO.removeItem(item.id)
        await item.unTrash()
        setStatus(Status.standard)
      } : undefined}
      onRemove={props.allowRemove ? async () => {
        setStatus(Status.loading)
        await buildingBlocksDTO.removeItem(item.id)
        const e = new EventDTO(item)
        if (props.locationId) {
          await e.unsetLocation()
        } else if (props.personId) {
          await e.removePerson(props.personId)
        } else if (props.customerLocationId) {
          await e.unsetCustomerLocation()
        } else if (props.customerId) {
          await e.unsetCustomer()
        }
        setStatus(Status.standard)
      } : undefined}
      compact={props.compact}
      personId={props.personId}
    />
    if (displayKind === 'gantt') {
      const pg = prepareGantt.items[index]
      let beforeCells = []
      let afterCells = []
      let startDay = new Date(prepareGantt.min)
      for (let i = 0, m = pg?.cellsBefore || 0; i < m; i++) {
        beforeCells.push({
          date: DateAddDays(startDay, i)
        })
      }
      for (let i = 0, m = pg?.cellsAfter || 0; i < m; i++) {
        afterCells.push({
          date: DateAddDays(startDay, (pg?.cellsBefore || 0) + (pg?.span || 0) + i)
        })
      }
      return <tr>
        {
          beforeCells.map((bc, index) => {
            return <td
              key={`gantt-${item.id}-before-${index}`}
              title={DisplayDate(bc.date)}
            ></td>
          })
        }
        <td
          colSpan={pg?.span}
        >
          {displayEvent}
        </td>
        {
          afterCells.map((bc, index) => {
            return <td
              key={`gantt-${item.id}-after-${index}`}
              title={DisplayDate(bc.date)}
            ></td>
          })
        }
      </tr>
    } else {
      return displayEvent
    }
  })
  

  // Select the right Menu item:
  let menuItem = MItem.planer
  if (props.mode === 'trash') {
    menuItem = MItem.trash
  } else if (objectKind === ObjectKind.seminar) {
    menuItem = MItem.designer
  } else if (props.leads === 'leads') {
    menuItem = MItem.leads
  }

  /*
  if (displayKind === 'trainerGantt') {
    return <PlaningToolRoot standalone={props.standalone} menuItem={menuItem}>
      <TrainersGantt
        buildingBlocksDTO={buildingBlocksDTO}
      />
    </PlaningToolRoot>
  }
  */

  return <PlaningToolRoot standalone={props.standalone} menuItem={menuItem}>
    { (props.standalone || props.headline) ?
      <div className='contentHeader'>
        {
          props.headline ? <h2>{props.headline}</h2> : <h1>{objectKind === ObjectKind.seminar ? 'Veranstaltungsdesigns' : (props.leads === 'leads' ? 'Leads' : 'Veranstaltungen')}</h1>
        }
        <TrashMenu
          menuItem={menuItem}
          objectKind={objectKind}
        />
        <Stack
          spacing={2}
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {
          !props.noSearch && displayKind !== 'trainerGantt90' ?
            <>
              
              <InputB
                className='flex-grow'
                returnVal={async (val) => {
                  setStatus(Status.loading)
                  let localNeedle = (val === undefined) ? '' : val
                  let props: IProp[] = []

                  // Search by Unique Event Id
                  const uniqueEventIdScope = /#([0-9a-zA-Z_-]+) ?/
                  const uniqueEventIdInfoRaw = localNeedle.match(uniqueEventIdScope)
                  if (uniqueEventIdInfoRaw) {
                    localNeedle = localNeedle.replace(uniqueEventIdScope, '')
                    props.push({id: -1, key1: 'data', key2: 'uniqueEventId', value1: uniqueEventIdInfoRaw[1], value2: ''})
                  }

                  // Search by Offer ID
                  const offerIdScope = /\$([0-9a-zA-Z_-]+) ?/
                  const offerIdInfoRaw = localNeedle.match(offerIdScope)
                  if (offerIdInfoRaw) {
                    localNeedle = localNeedle.replace(offerIdScope, '')
                    props.push({id: -1, key1: 'data', key2: 'offerId', value1: offerIdInfoRaw[1], value2: ''})
                  }

                  await buildingBlocksDTO.setElementKindPage(0, objectKind, publishKind, localNeedle, props)
                  setGlobNeedle(val)
                  setStatus(Status.standard)
                }}
                placeholder={searchPlaceholder}
                value={Needle}
                clearButton={true}
                sendButton="Suchen"
                delay={-1}
              />
            </> : null
          }
          {
            (props.minDateFilter && minDate) ?
              <InputB
                value={DisplayPHPDate(minDate)}
                returnVal={(value: string) => {
                  setStatus(Status.loading)
                  buildingBlocksDTO.minDate = value
                  setGlobMinDate(new Date(value))
                  buildingBlocksDTO.setElementKindPage(0, objectKind, publishKind).then(() => {
                    setStatus(Status.standard);
                  });
                }}
                noGrouping={true}
                type='date'
              />
            : undefined
          }
          {
            !props.noSearch && displayKind !== 'trainerGantt90' ?
            <Help>
                <h2>Suchfunktionen im Überblick</h2>
                <div>Einfach tippen und ein paar Sekunden warten. Dann werden automatisch die passenden Ergebnisse geladen.</div>
                {
                  objectKind === ObjectKind.event && 
                  <div>
                    <h3>Sonderfunktionen</h3>
                    <ul>
                      <li>Um Nach Trainern zu filtern die Trainer E-Mail eingeben</li>
                      <li>Um nach Veranstaltungsnummern zu suchen die Rautetaste (#) Drücken gefolgt von den ersten Ziffern. Beispiel: <pre>#2024</pre></li>
                      <li>Um nach Angebotsnummern zu suchen mit dem Dollarzeichen beginnen und ebenfalls die ersten Ziffern eintippen. Beispiel: <pre>$42</pre> </li>
                      <li>Um nach dem Unternehmen von Teilnehmern zu suchen das Prozentzeichen (%) tippen gefolgt von den ersten Buchstaben des Unternehmens. Beispiel <pre>%Imper</pre></li>
                    </ul>
                    <h3>Achtung</h3>
                    <div>Der Datumsfilter auf der Rechtenseite beschränkt die gefundenen Datensätze. Es werden nur Daten angezeigt die folgende Bedingungen erfüllen:
                      <li>Das Enddatum der Veranstaltung is neuer als das eingestellte Datum</li>
                      <li>Das Enddatum der Veranstaltung wurde noch nicht gesetzt</li>
                    </div>
                  </div>
                }
              </Help> : null
          }
        </Stack>

        
        {
          props.standalone && objectKind === ObjectKind.event && props.mode !== 'trash' &&
          <div className='flex w100'>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={DisplayKinds.findIndex(k => k.key === displayKind)} onChange={
                (event: React.SyntheticEvent, newValue: number) => {
                  const i = DisplayKinds[newValue]
                  let localNeedle = (Needle === undefined) ? '' : Needle
                  if (i.key === 'trainerGantt90') {
                    localNeedle = ''
                  }
                  setDisplayKind(i.key)
                  mainservice.nav.setPage(DisplayKinds.findIndex(k => k.key === i.key) || 0) 
                  infinitScroll.lock()
                  if (i.key === 'listwithoutdate') {
                    setMinDate(null)
                    buildingBlocksDTO.minDate = ''
                    infinitScroll.setPage(0)
                    setStatus(Status.loading);
                    buildingBlocksDTO.setElementKindPage(0, undefined, publishKind).then(() => {
                      setStatus(Status.standard);
                      infinitScroll.unlock()
                    });
                  } else if(i.key !== 'listwithoutdate' && minDate === null) {
                    const newMinDate = minDateSaverService.get()
                    setMinDate(newMinDate)
                    buildingBlocksDTO.minDate = DisplayPHPDate(newMinDate)
                    infinitScroll.setPage(0)
                    setStatus(Status.loading);
                    buildingBlocksDTO.setElementKindPage(0, undefined, publishKind, localNeedle).then(() => {
                      setStatus(Status.standard);
                      infinitScroll.unlock()
                      // mainservice.nav.setPage(DisplayKinds.findIndex(k => k.key === i.key) || 0) 
                      // setDisplayKind(i.key)
                    });
                  } else if (i.key === 'trainerGantt90') {
                    infinitScroll.setPage(0)
                    setStatus(Status.loading);
                    buildingBlocksDTO.setElementKindPage(0, undefined, publishKind, localNeedle).then(() => {
                      setStatus(Status.standard);
                      infinitScroll.unlock()
                      // mainservice.nav.setPage(DisplayKinds.findIndex(k => k.key === i.key) || 0) 
                      // setDisplayKind(i.key)
                    });
                  } else {
                    infinitScroll.unlock()
                    // mainservice.nav.setPage(DisplayKinds.findIndex(k => k.key === i.key) || 0) 
                    // setDisplayKind(i.key)
                  }
                }
              } aria-label="basic tabs example">
                {
                  DisplayKinds.map(i => <Tab
                    key={`display-kind-${i.key}`}
                    label={i.name}
                    id={i.key}
                  />)
                }
              </Tabs>
            </Box>
          </div>
        }
        {
          (Needle !== '' && !props.noNew) &&
          <button
            className='positiveButton'
            onClick={async () => {
              // If this is Event - we will call a Wizard, otherwise we just create new and visit the new Design:
              if (objectKind === ObjectKind.event) {
                setStatus(Status.new)
                return
              }
              const design = new SeminarDTO({
                id: -1,
                publishKind: publishKind
              })
              await design.setName(Needle)
              mainservice.navTo([['view', 'spVeranstaltungsDesigner'], ['id', design.id]])
            }}
          ><Plus /></button>
        }
      </div> : null
    }
    <div
      ref={infinitScroll.getRef()}
      className={`EventList ${props.className || ''} ${displayKind === 'gantt' ? 'DisplayStyleGantt' : 'DisplayStyleList'}`}
    >
      {
          status === Status.loading &&
          (
            props.compact === 'participated' ? 
            <Spinner mini /> : <Spinner />
          )
        }
      {
        status === Status.new &&
        <CreateEvent
          cancel={() => {
            setStatus(Status.standard)
          }}
          customerId={props.customerId || -1}
          customerLocationId={props.customerLocationId || -1}
          locationId={props.locationId || -1}
          personId={props.personId || -1}
          name={Needle}
          onCreate={props.onSelect}
        />
      }
      <div>
        { props.noSearch === false &&
          <InputB
            className='w3-border'
            returnVal={async (val) => {
              setStatus(Status.loading)
              const localNeedle = (val === '') ? undefined : val
              await buildingBlocksDTO.setElementKindPage(0, objectKind, publishKind, localNeedle)
              setGlobNeedle(val)
              setStatus(Status.standard)
            }}
            placeholder={`Tippen um zu suchen oder neu anzulegen ... ${objectKind === ObjectKind.event ? 'Um Nach Trainern zu filtern die Trainer E-Mail eingeben.' : ''}`}
            sendButton="Suchen"
            delay={-1}
          />
        }
      </div>
      <div
        className='EventListList flex-grow'
      >
        { (displayKind === 'list' || displayKind === 'listwithoutdate') &&
          <>
            {props.standalone &&
              <EventHeader />
            }
            {displayItems}
          </>
        }
        {
          displayKind === 'gantt' &&
          <div  className='ganttRoot'>
            <table>
              <tbody>
                {displayItems}
              </tbody>
            </table>
          </div>
        }
        {
          displayKind === 'trainerGantt' &&
          <TrainersGantt
            buildingBlocksDTO={buildingBlocksDTO}
            items={items}
          />
        }
        {
          displayKind === 'trainerGantt90' &&
          <TrainersGantt90
            buildingBlocksDTO={buildingBlocksDTO}
            items={items}
            page={page}
            startDate={minDate}
          />
        }
        {
          status === Status.loadMore &&
          <div className='textCenter'>
            <Spinner mini={true} />
            <div>Lade weitere Elemente</div>
          </div>
        }
      </div>
      {
        status !== Status.loading && buildingBlocksDTO.showItems.length === 0 &&
        <Alert className="flexGrow" severity="info">Keine Veranstaltungen vorhanden</Alert>
      }
    </div>
  </PlaningToolRoot>
}

function CreateEvent(props: {
  cancel: () => void,
  customerId?: number,
  customerLocationId?: number,
  locationId?: number,
  personId?: number,
  name?: string,
  onCreate?: (id: number, item: EventDTO) => void,
}) {
  const [name, setName] = useState(props.name || '')
  const [seminarId, setSeminarId] = useState(-2)
  const [templateName, setTemplateName] = useState('Keine Vorlage gewählt')
  const broadCastBackKeySeminarAdd = `EventSeminarAddFor-new`;
  mainservice.registerToBroadcast(`EventEdit-new`,
    async (key: string, _value: any) => {
      if (key === broadCastBackKeySeminarAdd) {
        setSeminarId(_value.id)
        setTemplateName(
          parseStringFromServer(_value.name)
        )
      }
    }
  );
  return <div
    className='CreateEvent w3-padding w3-border w3-border-green'
  >
    <h2>Neues Event erstellen</h2>
    <label>Name</label>
    <InputB
      className='EventListEditName'
      returnVal={(v) => setName(v)}
      value={name}
    />
    <BroadcastRightButton
        contentType={RightDrawerContent.selectSeminar}
        broadCastBackKey={broadCastBackKeySeminarAdd}
        title={`Veranstaltungsvorlage wählen`} />
    <div className='w3-margin'>{templateName}</div>
    
    <Button
      variant="contained"
      onClick={async () => {
        const event = new EventDTO({id: -1})
        await event.setName(name)
        if (seminarId > -1) {
          await event.addUp(seminarId)
        }
        if ((props.customerId !== undefined) && props.customerId > -1) {
          await event.addCustomer(props.customerId)
        }
        if ((props.customerLocationId !== undefined) && props.customerLocationId > -1) {
          await event.addCustomer(props.customerLocationId)
        }
        if ((props.locationId !== undefined) && props.locationId > -1) {
          await event.setLocation(props.locationId)
        }
        if ((props.personId !== undefined) && props.personId > -1) {
          await event.addPerson(props.personId)
        }
        if (props.onCreate) {
          props.onCreate(event.id, event)
        }
        mainservice.navTo([['view', 'spVeranstaltungsDetails'], ['id', event.id]])
      }}
    >Speichern</Button>
    <button className='w3-button w3-grey' onClick={props.cancel}>Abbrechen</button>

  </div>
}

function EventHeader() {
  if (mainservice.nav.getVal('view') === 'spVeranstaltungsPlaner' || mainservice.nav.getVal('view') === 'spVeranstaltungsLeads') {
    return <div className='EventHeader'>
      <div className='th' style={{paddingLeft: '16px'}}>Veranstaltung</div>
      <div className='th'>Auftragsstatus</div>
      <div className='th'>Event Art</div>
      <div className='th'>Abrechnungsstatus</div>
      
      { false && <div className='th'>Fertigstellungs Prio</div> }
      <div className='th'>Kunde</div>
      <div className='th'>BTC</div>
      <div className='th'></div>
    </div>
  }
  
  if (mainservice.nav.getVal('view') === 'spVeranstaltungsDesigns') {
    return <div className='EventHeader'>
      <div className='th'>Designname</div>
      <div className='th'>Themen</div>
      <div className='th'>Fertigstellung</div>
      <div className='th'></div>
    </div>
  }
  return null
}

function TrashMenu(props: {
  menuItem: MItem,
  objectKind: ObjectKind,
}) {
  const [objectKind, setObjectKind] = useState(props.objectKind)
  useEffect(() => {
    setObjectKind(props.objectKind)
  }, [props.objectKind])

  const TrashItems = [
    {
      name: 'Veranstaltungen',
      view: 'spPapierkorb',
      objectKind: ObjectKind.event,
    },
    {
      name: 'Designs',
      view: 'spPapierkorbDesigns',
      objectKind: ObjectKind.seminar,
    },
  ]
  if (props.menuItem !== MItem.trash) { return null }
  return <div className="flex w100">
    {
      TrashItems.map(tI => <button
        key={`TrashItemButton${tI.objectKind}`}
        className={`tab-button ${objectKind === tI.objectKind ? 'tab-active' : ''}`}
        onClick={() => {
          mainservice.navTo([['view', tI.view]])
        }}
      >{tI.name}</button>)
    }
  </div>
}
